export const FUNCTIONALITIES = {
  createExportDeclaration: "CREATE_EXPORT_DECLARATION",
  profileOffice: "PROFILE_OFFICE",
};
